import { render, staticRenderFns } from "./IvSerumCard.vue?vue&type=template&id=2dcdef18"
import script from "./IvSerumCard.vue?vue&type=script&lang=js"
export * from "./IvSerumCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports